import React, { useState } from 'react';
import {
  Autocomplete,
  TextField,
} from '@mui/material';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import '../../../App.css';
import getAllUsers from '../helper-methods/getAllUsers';
import useStore from '../state-files/zustondStoreStates';
import { apiUrlPrefix } from '../../../config';
import Cookies from 'js-cookie';

const GetUsers = ({ formik, setName, currentUser, isAll }) => {
  const [open, setOpen] = useState(false);
  const { setUserData } = useStore(); // Use zustand store

  // Use TanStack Query to manage the user list
  const { data: usersData } = useQuery({
    queryKey: ['allUsers'],
    queryFn: () => getAllUsers(),
    enabled: open, // Only fetch when the dialog is opened
  });

  // FIX: Wrap the store update in useEffect
  React.useEffect(() => {
    if (usersData) {
      setUserData(usersData);
    }
  }, [usersData, setUserData]); // Only runs when usersData actually changes

  var options;
  if (isAll) {
    // Create the options array: Start with 'All', then add names from the fetched data
    options = ['All', ...(usersData?.map(user => user.name) || [])];
  } else {
    // Create the options array: Start with 'All', then add names from the fetched data
    options = [...(usersData?.map(user => user.name) || [])];
  }


  return (
    <Autocomplete
      multiple // This is the key prop for multiple selection
      id="users-search-select"
      options={options}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option?.name || "")}
      isOptionEqualToValue={(option, value) => option === value}
      // Formik 'users' value will now be an array, e.g., ['All', 'User1']
      value={formik.values.users || []}
      onChange={(event, newValue) => {
        // 1. Identify what was just added by comparing newValue with current state
        const lastSelected = newValue[newValue.length - 1];

        let updatedValue = newValue;

        // 2. Logic: If "All" was just selected, make it the ONLY selection
        if (lastSelected === 'All') {
          updatedValue = ['All'];
        }
        // 3. Logic: If a specific user was added and "All" is in the list, remove "All"
        else if (newValue.length > 1 && newValue.includes('All')) {
          updatedValue = newValue.filter((user) => user !== 'All');
          if(currentUser !== undefined && currentUser !== null & currentUser !== '') {
          updatedValue = [...updatedValue, currentUser];
          }
        }
        else if (!newValue.includes('All') && !newValue.includes(currentUser)) {
          
          if(currentUser !== undefined && currentUser !== null & currentUser !== '') {
            updatedValue = [...updatedValue, currentUser];
          }
        }

        // 4. Update Formik with the cleaned array
        formik.setFieldValue('users', updatedValue);
      }}
      onBlur={formik.handleBlur}
      renderInput={(params) => (
        <TextField
          {...params}
          margin="dense"
          label="Users"
          variant="outlined"
          placeholder="Select users..."
          onKeyDown={(e) => {
            // This stops the 'a', 'd', 'h', 'l' from reaching your global shortcuts
            e.stopPropagation();
          }}
          error={formik.touched.users && Boolean(formik.errors.users)}
          helperText={formik.touched.users && formik.errors.users}
        />
      )}
    />
  )
};

export default GetUsers;